// src/hooks/useProducts.js
import { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';
import { CATEGORIES } from '../data/products'; // keep categories static

export { CATEGORIES };

export function useProducts() {
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const snap = await getDocs(collection(db, 'products'));
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          // Only show active products (isActive !== false means show it)
          .filter((p) => p.isActive !== false);
        setProducts(list);
      } catch (err) {
        console.error('Failed to fetch products:', err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  return { products, loading };
}
